import TambahStockFisik from "./TambahStockFisik";

export default TambahStockFisik;
